import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'accela-button-primary',
  templateUrl: './accela-button-primary.component.html',
  styleUrls: ['./accela-button-primary.component.css']
})
export class AccelaButtonPrimaryComponent implements OnInit {

  @Output('onClicked') clickEmitter = new EventEmitter<any>(true);

  @Input('icon') iconName: string;
  @Input('iconPos') iconPosition: string;
  @Input('label') labelContent: string;
  @Input('disabled') processing: boolean;
  @Input() accessButton: string = null;
  
  constructor() { }

  ngOnInit(): void {
  }

  click(event: any){
    this.clickEmitter.emit(event);
  }
}
